/* SKU barcode (Code 128, set B) for the product page — Omah Lempung.
   Draws an SVG barcode from the SKU shown in [data-sku] and redraws it when the
   variant (and so the SKU) changes. No dependencies. */
(function () {
  'use strict';
  if (window.OLBarcode) return;

  // Code 128 module widths (bar, space, bar, space, bar, space) for values 0–106.
  var P = [
    '212222','222122','222221','121223','121322','131222','122213','122312','132212','221213',
    '221312','231212','112232','122132','122231','113222','123122','123221','223211','221132',
    '221231','213212','223112','312131','311222','321122','321221','312212','322112','322211',
    '212123','212321','232121','111323','131123','131321','112313','132113','132311','211313',
    '231113','231311','112133','112331','132131','113123','113321','133121','313121','211331',
    '231131','213113','213311','213131','311123','311321','331121','312113','312311','332111',
    '314111','221411','431111','111224','111422','121124','121421','141122','141221','112214',
    '112412','122114','122411','142112','142211','241211','221114','413111','241112','134111',
    '111242','121142','121241','114212','124112','124211','411212','421112','421211','212141',
    '214121','412121','111143','111341','131141','114113','114311','411113','411311','113141',
    '114131','311141','411131','211412','211214','211232','2331112'
  ];

  // Returns the module widths of the whole symbol, or null if the text can't be encoded in set B.
  function encode(text) {
    var codes = [104]; // Start B
    for (var i = 0; i < text.length; i++) {
      var c = text.charCodeAt(i);
      if (c < 32 || c > 126) return null;
      codes.push(c - 32);
    }
    var sum = codes[0];
    for (var k = 1; k < codes.length; k++) sum += codes[k] * k;
    codes.push(sum % 103); // check symbol
    codes.push(106);       // stop
    return codes.map(function (v) { return P[v]; }).join('');
  }

  function svg(text) {
    var w = encode(text);
    if (!w) return '';
    var quiet = 10, x = quiet, bars = '';
    for (var i = 0; i < w.length; i++) {
      var n = +w[i];
      if (i % 2 === 0) bars += 'M' + x + ' 0h' + n + 'v1h-' + n + 'z';
      x += n;
    }
    var total = x + quiet;
    // ~1.3px per module keeps every bar crisp and wide enough for phone and counter scanners.
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + Math.round(total * 1.3) + '" viewBox="0 0 ' + total + ' 1" preserveAspectRatio="none" ' +
      'shape-rendering="crispEdges" aria-hidden="true" focusable="false"><path d="' + bars + '" fill="currentColor"/></svg>';
  }

  function draw(card) {
    var skuEl = card.querySelector('[data-sku]');
    var box = card.querySelector('[data-barcode]');
    var sku = skuEl ? (skuEl.textContent || '').trim() : '';
    var markup = sku && !skuEl.hidden ? svg(sku) : '';
    card.hidden = !sku || (skuEl && skuEl.hidden);
    if (box) {
      box.innerHTML = markup;
      box.hidden = !markup;
      box.setAttribute('aria-label', (box.dataset.label || 'Barcode') + ': ' + sku);
    }
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-sku-card]'), function (card) {
      if (card._olbc) return;
      card._olbc = true;
      draw(card);
      var skuEl = card.querySelector('[data-sku]');
      if (skuEl && 'MutationObserver' in window) {
        new MutationObserver(function () { draw(card); })
          .observe(skuEl, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      }
    });
  }

  window.OLBarcode = { encode: encode, svg: svg, init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
